import { Component, OnInit, ViewChild, ErrorHandler } from '@angular/core';
declare var $: any;
import { DataTableDirective } from 'angular-datatables';
import { UserService } from '../../../../shared/user.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import swal from 'sweetalert2';
@Component({
  selector: 'app-qualificationgrid',
  templateUrl: './qualificationgrid.component.html',
  styleUrls: ['./qualificationgrid.component.css']
})
export class QualificationgridComponent implements OnInit {
  title="Qualification Details";
  // data: any;
  // QualificationList: any[] = [];
  // dtOptions: any = {};
  // empList :any =[];
  // mode :any;
  // @ViewChild(DataTableDirective)
  // dtTrigger: Subject<any> = new Subject();
  // @ViewChild(DataTableDirective) dtElement: DataTableDirective;

  dtOptions: any = {};
  QualificationList: any[] = [];
  mode: any;
  @ViewChild(DataTableDirective)
  datatableElement: DataTableDirective;
  data: any;
  dtTrigger: Subject<any> = new Subject();
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;

  constructor(private UserService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler) { }

  ngOnInit() {
    this.GetAllQualificationDetails();
    $(document).ready(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
    this.dtOptions = {

      dom: 'lBfrtip',
      lengthMenu: [[5, 10, 20, -1], [5, 10, 20, "All"]],
      scroll: "250px",
      select: true,
      buttons: [
        {
          extend: 'collection',
          text: 'Export',
          className: 'btn btn-radius',
          buttons: ['copy', 'csv', 'excel', 'pdf', 'print',]
        },
        { extend: 'colvis', text: 'Column Visibility', className: 'btn btn-radius' }
      ],
    }
  }

  GetAllQualificationDetails() {
    debugger;
    this.data = this.UserService.GetAllQualificationDetails();
    this.data.subscribe((Response: any) => {
      this.QualificationList = Response.Result;
      this.rerender();
    }, (error) => {
      if (error.status == 401 || error.status == 500) {
        this.errorHandler.handleError(error);
      }
      else if (error.status == 400) {
        swal('Warning!', error.error.Message, 'warning');
      }
    });
  }

  DeleteQualificationDetails(QU_Id: number) {
    debugger
    Swal.fire({
      position: 'top-end',
      title: 'Do You Want To Delete',
      text: 'If Deleted, Data can not be reverted back!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.value) {
        this.UserService.DeleteQualificationDetails(QU_Id).subscribe(
          (data: any) => {
            Swal.fire('Data Record Deleted Successfully..')
          }, (error) => {
            Swal.fire('Changes will be Discarded..')
          });
      }
    })
  }

   /*for Datatable*/
   ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    try {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
      });
     this.dtTrigger.next();
    } catch (err) {
      console.log(err);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/Pages/manage/qualification/qualificationgrid/qualificationgrid.component.ts